import { RootState } from 'store';

const EquipmentsLookupState = (state: RootState) => state.lookups.equipments;

export const selectEquipments = (state: RootState) => EquipmentsLookupState(state).rows;
